(() => {
  /* BEZELOR SUPER DEALS: countdown, add to cart, carousel arrows, and hiding deals once they end.
     The end time comes from the page (saved by the daily Flow run). If a cached page is opened
     after the deals ended, the prices are hidden straight away and the section reloads itself. */
  if (window.BzSuperDeals) {
    window.BzSuperDeals.init(document);
    return;
  }

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const pad = (n) => (n < 10 ? '0' : '') + n;
  const parts = (ms) => {
    const total = Math.max(0, Math.floor(ms / 1000));
    return { h: Math.floor(total / 3600), m: Math.floor((total % 3600) / 60), s: total % 60 };
  };

  /* The countdown uses the store's clock, not the shopper's: a computer set to the wrong
     date would otherwise show the wrong time left (or hide live deals). */
  let offset = 0;
  let synced = false;
  const syncClock = async () => {
    try {
      const response = await fetch(root() + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
      const server = Date.parse(response.headers.get('date'));
      if (Number.isFinite(server)) offset = server - Date.now();
    } catch (e) {
      /* keep the device clock */
    }
    synced = true;
    tick();
  };

  /* Product page: deal price for the variant the shopper has selected (same rounding as Shopify:
     each item's discount is rounded down to the penny) */
  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  };
  function updatePdp() {
    document.querySelectorAll('[data-sd-pdp]').forEach((box) => {
      if (box.dataset.sdShowPrice !== 'true') return;
      const scope = box.closest('product-info') || document;
      const input = scope.querySelector('form[action*="/cart/add"] input[name="id"]') || document.querySelector('form[action*="/cart/add"] input[name="id"]');
      /* Variant prices only need parsing when the selected variant changes. */
      if (!input || box.dataset.sdVariant === input.value) return;
      let prices;
      try {
        prices = JSON.parse(box.dataset.sdPrices || '{}');
      } catch (e) {
        return;
      }
      const entry = prices[input.value];
      if (!Array.isArray(entry)) return;
      box.dataset.sdVariant = input.value;
      const price = entry[0];
      const original = Math.max(entry[1] || 0, price);
      const value = parseFloat(box.dataset.sdValue);
      let off = box.dataset.sdType === 'fixed' ? Math.round(value * 100) : Math.floor((price * value) / 100 + 0.00001);
      off = Math.min(off, price);
      const dealPrice = price - off;
      const totalOff = original - dealPrice;
      const currency = box.dataset.sdCurrency || 'GBP';
      const set = (selector, text) => {
        const node = box.querySelector(selector);
        if (node) node.textContent = text;
        return node;
      };
      set('[data-sd-deal]', money(dealPrice, currency));
      const was = set('[data-sd-was]', money(original, currency));
      if (was) was.hidden = original <= dealPrice;
      set('[data-sd-sale]', money(price, currency));
      const saleRow = box.querySelector('[data-sd-row-sale]');
      if (saleRow) saleRow.hidden = original <= price;
      set('[data-sd-extra]', money(off, currency));
      set('[data-sd-save]', money(totalOff, currency));
      if (original > 0) set('[data-sd-pct]', '-' + Math.round((totalOff * 100) / original) + '%');
    });
    /* While the deal runs, the sticky add-to-cart bar shows the deal price too; when it ends,
       the theme's own price and offers come back (see bezelor-super-deals-extras.liquid) */
    const box = document.querySelector('[data-sd-pdp]');
    if (!box) return;
    const ended = box.classList.contains('is-expired');
    document.documentElement.classList.toggle('bz-sd-pdp-ended', ended);
    const sticky = document.querySelector('.bezelor-sticky-cart__meta span');
    const deal = box.querySelector('[data-sd-deal]');
    if (sticky && deal && box.dataset.sdShowPrice === 'true') {
      if (!sticky.dataset.sdOriginal) sticky.dataset.sdOriginal = sticky.textContent;
      const text = ended ? sticky.dataset.sdOriginal : deal.textContent;
      if (sticky.textContent !== text) sticky.textContent = text;
    }
  }

  /* Countdown digits flip when they change. Same keyframes as bzSdFlip in the CSS, played through the
     Web Animations API: restarting a CSS class needed a forced layout (offsetWidth) every second. */
  const FLIP_EASE = 'cubic-bezier(0.2, 0.8, 0.2, 1)'; /* per keyframe, exactly like a CSS animation-timing-function */
  const FLIP = [
    { transform: 'rotateX(85deg)', color: '#f3dc95', boxShadow: '0 0 22px 2px rgb(243 220 149 / 0.45), 0 0 0 1px rgb(243 220 149 / 0.8)', easing: FLIP_EASE },
    { transform: 'rotateX(-10deg)', offset: 0.6, easing: FLIP_EASE },
    { transform: 'none' },
  ];
  const calmMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function flip(node, text) {
    if (!node || node.textContent === text) return;
    node.textContent = text;
    if (calmMotion.matches || typeof node.animate !== 'function' || node.closest('.is-offscreen')) return;
    node.animate(FLIP, { duration: 550 });
  }

  let ticking = false;
  function tick() {
    if (!synced) return;
    updatePdp();
    const now = Date.now() + offset;
    document.querySelectorAll('[data-sd-countdown]').forEach((el) => {
      /* Skip invisible digit/ring writes, but continue checking deal expiry below. */
      if (el.closest('[data-sd-section].is-offscreen')) return;
      const end = Date.parse(el.dataset.sdEnd);
      if (!Number.isFinite(end)) return;
      const left = end - now;
      const p = parts(left);
      if (el.dataset.sdFormat === 'blocks') {
        flip(el.querySelector('[data-sd-h]'), pad(p.h));
        flip(el.querySelector('[data-sd-m]'), pad(p.m));
        flip(el.querySelector('[data-sd-s]'), pad(p.s));
        /* Gold ring around the seconds, and the bar showing how much of today's deal time is left */
        el.style.setProperty('--sd-sec', String(p.s));
        const start = Date.parse(el.dataset.sdStart);
        const bar = el.parentElement && el.parentElement.querySelector('[data-sd-daybar]');
        if (bar && Number.isFinite(start) && end > start) {
          /* 0.1% steps: the bar still glides down, but its 1s width transition (a layout every frame) runs every ~90s instead of non-stop */
          const width = Math.round(Math.max(0, Math.min(1, left / (end - start))) * 1000) / 10 + '%';
          if (bar.style.width !== width) bar.style.width = width;
        }
      } else {
        el.textContent = pad(p.h) + 'h ' + pad(p.m) + 'm ' + pad(p.s) + 's';
      }
    });
    document.querySelectorAll('[data-sd-box]:not(.is-expired)').forEach((el) => {
      const end = Date.parse(el.dataset.sdEnd);
      if (Number.isFinite(end) && now >= end) el.classList.add('is-expired');
    });
    document.querySelectorAll('[data-sd-section]').forEach((section) => {
      const end = Date.parse(section.dataset.sdEnd);
      if (section.dataset.sdStatus === 'live' && Number.isFinite(end) && now >= end) expire(section);
      /* Safety: never keep a section hidden while its deals are still running */
      else if (section.classList.contains('is-expired') && Number.isFinite(end) && now < end - 5000) {
        section.classList.remove('is-expired');
        const note = section.querySelector('[data-sd-refresh]');
        if (note) note.hidden = true;
      }
    });
  }

  function startTicking() {
    if (ticking) return;
    ticking = true;
    setTimeout(() => {
      if (!synced) {
        synced = true;
        tick();
      }
    }, 3000);
    syncClock();
    setInterval(tick, 1000);
  }

  /* Deals ended: hide prices, then ask Shopify for the section again until the new deals are live */
  function expire(section) {
    if (section.classList.contains('is-expired')) return;
    section.classList.add('is-expired');
    const note = section.querySelector('[data-sd-refresh]');
    if (note) note.hidden = false;
    poll(section, 0);
  }

  function poll(section, attempt) {
    if (attempt > 40) return;
    const id = section.dataset.sdSection;
    const oldDay = section.dataset.sdDay;
    setTimeout(async () => {
      try {
        const url = window.location.pathname + '?section_id=' + encodeURIComponent(id) + '&sd=' + Date.now();
        const html = await fetch(url, { cache: 'no-store' }).then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-sd-section]');
        if (!section.isConnected) return;
        if (fresh && fresh.dataset.sdStatus === 'live' && fresh.dataset.sdDay !== oldDay) {
          section.replaceWith(fresh);
          init(fresh.parentNode || document);
          return;
        }
      } catch (e) {
        /* try again on the next round */
      }
      poll(section, attempt + 1);
    }, attempt === 0 ? 20000 : 60000);
  }

  /* Add to cart: uses the theme's cart drawer when there is one, otherwise goes to the cart page */
  async function addToCart(form) {
    const button = form.querySelector('button[type="submit"]');
    const label = form.querySelector('[data-sd-add-label]');
    const id = form.querySelector('input[name="id"]').value;
    const original = label ? label.textContent : '';
    if (button) button.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Adding…';
    try {
      const drawer = document.querySelector('cart-drawer');
      const response = await fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(id), quantity: 1 }],
          sections: drawer ? 'cart-drawer,cart-icon-bubble' : undefined,
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Could not add this item.');
      if (drawer && data.sections && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        drawer.renderContents({ id: id, sections: data.sections });
      } else {
        window.location.href = root() + 'cart';
        return;
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bezelor-super-deals', productVariantId: id });
      }
      if (label) label.textContent = 'Added ✓';
      setTimeout(() => {
        if (label) label.textContent = original;
      }, 2000);
    } catch (error) {
      if (label) label.textContent = error.message.length < 40 ? error.message : 'Try again';
      setTimeout(() => {
        if (label) label.textContent = original;
      }, 3000);
    } finally {
      if (button) button.removeAttribute('aria-busy');
    }
  }

  function initCarousel(section) {
    const track = section.querySelector('[data-sd-track]');
    const prev = section.querySelector('[data-sd-prev]');
    const next = section.querySelector('[data-sd-next]');
    if (!track || !prev || !next || track.dataset.sdReady) return;
    track.dataset.sdReady = 'true';
    const step = () => {
      const card = track.querySelector('.bz-sd__card');
      return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
    };
    const bar = section.querySelector('[data-sd-progress]');
    let updateFrame = 0;
    const update = () => {
      updateFrame = 0;
      // Read geometry together before changing button state or progress styles.
      const width = track.scrollWidth;
      const viewportWidth = track.clientWidth;
      const left = track.scrollLeft;
      const max = Math.max(width - viewportWidth, 0);
      prev.disabled = left <= 4;
      next.disabled = left >= max - 4;
      if (bar) {
        const share = width ? Math.min(viewportWidth / width, 1) : 1;
        const pos = max ? left / max : 0;
        bar.style.width = share * 100 + '%';
        bar.style.left = pos * (1 - share) * 100 + '%';
      }
    };
    const queueUpdate = () => {
      if (!updateFrame) updateFrame = requestAnimationFrame(update);
    };
    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', queueUpdate, { passive: true });
    window.addEventListener('resize', queueUpdate);
    update();

    /* Slides by itself every few seconds; pauses while the shopper hovers, touches or tabs into it,
       and when the section is off screen */
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (section.dataset.sdAutoplay !== 'true' || calm) return;
    let paused = false;
    let visible = false;
    let resumeTimer;
    const advance = () => {
      if (paused || !visible || document.hidden) return;
      const max = track.scrollWidth - track.clientWidth;
      if (max <= 4) return;
      if (track.scrollLeft >= max - 4) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: step(), behavior: 'smooth' });
    };
    const pause = () => {
      paused = true;
      clearTimeout(resumeTimer);
    };
    const resume = (delay) => {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => {
        paused = false;
      }, delay || 0);
    };
    const stage = section.querySelector('.bz-sd__stage') || track;
    stage.addEventListener('pointerenter', (e) => e.pointerType === 'mouse' && pause());
    stage.addEventListener('pointerleave', (e) => e.pointerType === 'mouse' && resume(600));
    stage.addEventListener('touchstart', pause, { passive: true });
    stage.addEventListener('touchend', () => resume(6000), { passive: true });
    section.addEventListener('focusin', pause);
    section.addEventListener('focusout', () => resume(3000));
    [prev, next].forEach((button) => button.addEventListener('click', () => {
      pause();
      resume(8000);
    }));
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        visible = entries[0].isIntersecting;
      }, { threshold: 0.35 }).observe(track);
    } else {
      visible = true;
    }
    setInterval(advance, 3600);
  }

  /* Cards rise in one after another when the section comes into view */
  function reveal(section) {
    if (section.dataset.sdRevealed) return;
    section.dataset.sdRevealed = 'true';
    if (!('IntersectionObserver' in window)) {
      section.classList.add('is-in');
      return;
    }
    section.classList.add('is-armed');
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const counters = calm ? [] : [...section.querySelectorAll('[data-sd-countup]')];
    counters.forEach((node) => (node.textContent = '0%'));
    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      section.classList.add('is-in');
      observer.disconnect();
      counters.forEach((node) => countUp(node, parseInt(node.dataset.sdCountup, 10) || 0));
    }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });
    observer.observe(section);
  }

  /* "Up to X%" counts up from 0 when the section comes into view */
  function countUp(node, target) {
    const begin = performance.now();
    const length = 1400;
    const step = (now) => {
      const t = Math.max(0, Math.min(1, (now - begin) / length));
      const eased = 1 - Math.pow(1 - t, 3);
      node.textContent = Math.round(target * eased) + '%';
      if (t < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
    /* Always land on the real number, even if the browser pauses animation frames */
    setTimeout(() => (node.textContent = target + '%'), length + 300);
  }

  /* Deals page: filter chips and sort */
  function initTools(section) {
    const tools = section.querySelector('[data-sd-tools]');
    const list = section.querySelector('[data-sd-track]');
    if (!tools || !list || tools.dataset.sdReady) return;
    tools.dataset.sdReady = 'true';
    const cards = [...list.querySelectorAll('[data-sd-card]')];
    const total = tools.querySelector('[data-sd-total]');
    const empty = section.querySelector('[data-sd-empty]');
    const select = tools.querySelector('[data-sd-sort]');
    let filter = 'all';
    const matches = (card) => {
      const pct = parseFloat(card.dataset.sdPct) || 0;
      const cents = parseFloat(card.dataset.sdCents) || 0;
      if (filter === 'all') return true;
      if (filter === 'big') return pct >= 40;
      const [low, high] = filter.split('-');
      return cents >= (parseFloat(low) || 0) && (high === '' || cents < parseFloat(high));
    };
    const apply = () => {
      let shown = 0;
      cards.forEach((card) => {
        const ok = matches(card);
        card.hidden = !ok;
        if (ok) shown += 1;
      });
      const mode = select ? select.value : 'saving';
      const sorted = [...cards].sort((a, b) => {
        const pa = parseFloat(a.dataset.sdCents) || 0;
        const pb = parseFloat(b.dataset.sdCents) || 0;
        if (mode === 'price-asc') return pa - pb;
        if (mode === 'price-desc') return pb - pa;
        return parseFloat(a.dataset.sdOrder) - parseFloat(b.dataset.sdOrder);
      });
      sorted.forEach((card) => list.append(card));
      if (total) total.textContent = '(' + cards.length + ')';
      if (empty) empty.hidden = shown > 0;
      tools.querySelectorAll('[data-sd-filter]').forEach((chip) => {
        const on = chip.dataset.sdFilter === filter;
        chip.classList.toggle('is-on', on);
        chip.setAttribute('aria-pressed', String(on));
      });
    };
    section.addEventListener('click', (event) => {
      const chip = event.target.closest('[data-sd-filter]');
      if (!chip || !section.contains(chip)) return;
      filter = chip.dataset.sdFilter;
      apply();
    });
    if (select) select.addEventListener('change', apply);
    apply();
  }

  /* Deals page: the dark background runs up behind the header, so header and page read as one */
  function initBlend(section) {
    if (!section.hasAttribute('data-sd-blend') || section.dataset.sdBlendReady) return;
    section.dataset.sdBlendReady = 'true';
    const header = document.querySelector('.shopify-section-group-header-group sticky-header, sticky-header');
    const holder = header && header.closest('.shopify-section');
    if (!holder) return;
    const measure = () => {
      /* Once the page is scrolled the sticky header sits at the top of the screen, so measuring then gives 0 and a white
         strip shows behind the menu (phones fire resize as the address bar hides). Measure only at the top; if the page
         opens already scrolled, use the header's own height. */
      if (window.scrollY > 2 && section.dataset.sdPullSet) return;
      let pull = holder.offsetHeight;
      if (window.scrollY <= 2) {
        /* Where the section would start without the pull, minus where the header starts */
        const margin = parseFloat(getComputedStyle(section).marginTop) || 0;
        const top = section.getBoundingClientRect().top + window.scrollY - margin;
        const headerTop = holder.getBoundingClientRect().top + window.scrollY;
        pull = Math.max(0, Math.round(top - headerTop));
      }
      section.style.setProperty('--sd-pull', pull + 'px');
      section.dataset.sdPullSet = 'true';
    };
    measure();
    window.addEventListener('resize', measure);
  }

  /* Off screen: the CSS pauses every animation in the section (class "is-offscreen"), so the moving
     background, sparks and shines cost nothing while the shopper is elsewhere on the page */
  function watch(section) {
    if (section.dataset.sdWatch || !('IntersectionObserver' in window)) return;
    section.dataset.sdWatch = 'true';
    new IntersectionObserver((entries) => {
      const offscreen = !entries[0].isIntersecting;
      section.classList.toggle('is-offscreen', offscreen);
      /* Refresh immediately when it becomes visible, including after background tabs. */
      if (!offscreen) tick();
    }, { rootMargin: '200px 0px' }).observe(section);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-sd-section]').forEach((section) => {
      initBlend(section);
      initCarousel(section);
      initTools(section);
      reveal(section);
      watch(section);
    });
    startTicking();
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest && event.target.closest('form[data-sd-add]');
    if (!form) return;
    event.preventDefault();
    addToCart(form);
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));

  window.BzSuperDeals = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
})();
